import React from 'react';
//@ts-ignore
import {GetCategoryFilters} from './../../themes/kent/utilities/dataFunctions';
//@ts-ignore
import {GeneralAssetUrl} from './../../themes/kent/utilities/constants';

import TextOverImageThumbGrid from './../text-over-image-thumb-grid/./text-over-image-thumb-grid';
/**
 *
 * Product Row component
 * @extends {React.Component}
 */
interface IProps {
  categories?: any;
  active?: boolean;
  columns?: any;
}
interface IState {
  menuContentActive?: any;
  animating?:boolean;
  active?:boolean;
}

class HeaderCategoryMenu extends React.Component<IProps>{

  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {};
  }

  componentDidUpdate = () =>{
    if(this.props.active && !this.state.menuContentActive && !this.state.animating){
      this.setState({
        active:true,
        animating:true,
        menuContentActive:false
      },()=>{
        setTimeout(() => {
          this.setState({
            animating:false,
            menuContentActive:true
          })
        }, 10);
      })
    }
    if(!this.props.active && !this.state.animating){
      this.setState({
        animating:true,
        menuContentActive:false
      },()=>{
        setTimeout(() => {
          this.setState({
            animating:false,
            active:false
          })
        }, 500);
      })
    }
  }

  public render(): JSX.Element {
    let menuActiveClass:string = "";
    let menuContentActiveClass:string = "";
    if(this.state.active){
      menuActiveClass = "active";
    }
    if(this.state.menuContentActive && this.props.active){
      menuContentActiveClass = "active";
    }

    return (
      <div className={"header-category-menu-wrapper "+menuActiveClass}>
       <div className={"header-category-menu "+menuContentActiveClass}>
         {this.props.categories &&
           <TextOverImageThumbGrid items={this.props.categories} smallColumns={'12'} mediumColumns={this.props.columns ? columnCoversionDictionary[this.props.columns] : '4'} height={'25vh'} />
         }
       </div>
      </div>
    );
 }
}

 export default HeaderCategoryMenu;

 export const columnCoversionDictionary:any = {
   six:'2',
   four:'3',
   three:'4',
   two:'6',
   one:'12'
 };
